import api from './api';

export const uploadFile = (spaceId, file, threadId = null, sharedWith = []) => {
  const formData = new FormData();
  formData.append('file', file);
  if (spaceId) formData.append('spaceId', spaceId);
  if (threadId) formData.append('threadId', threadId);
  if (Array.isArray(sharedWith) && sharedWith.length > 0) {
    formData.append('sharedWith', JSON.stringify(sharedWith));
  }

  return api.post('/files/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getDirectFiles = () => api.get('/files');

export const getSpaceFiles = (spaceId) => api.get(`/spaces/${spaceId}/files`);

const parseDownloadName = (contentDisposition, fallbackName) => {
  if (!contentDisposition) return fallbackName;
  const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utfMatch && utfMatch[1]) return decodeURIComponent(utfMatch[1]);
  const simpleMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  if (simpleMatch && simpleMatch[1]) return simpleMatch[1];
  return fallbackName;
};

export const downloadFile = async (fileId, fallbackName = 'download') => {
  const res = await api.get(`/files/${fileId}/download`, { responseType: 'blob' });
  const filename = parseDownloadName(res.headers['content-disposition'], fallbackName);

  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const openFile = async (fileId) => {
  const opened = window.open('', '_blank');
  if (!opened) {
    throw new Error('Pop-up blocked');
  }

  const res = await api.get(`/files/${fileId}`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: res.data?.type || res.headers['content-type'] }));
  opened.location.href = url;

  // Keep the blob URL alive long enough for the new tab to load it.
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 60000);
};

export const deleteFile = (fileId) => api.delete(`/files/${fileId}`);
